module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icn_check-710e0e6df1da408a42e25fd478f856a4.svg";